import { useMemo, useState } from 'react'
import { formatMoney } from '../../lib/format.js'
import BreakdownShell, { SortHeader, useSortedUnits, pctCell } from './BreakdownShell.jsx'

// SalesBreakdownTable — by-unit Today's Sales vs last week same day.
// Footer totals equal the headline KPI by construction (the server
// summed per-unit values into the headline).

export default function SalesBreakdownTable({ perUnit, onBack }) {
  // --- All hooks BEFORE any conditional return (React #310). ---
  const [sortKey, setSortKey] = useState('sales_today')
  const [sortDir, setSortDir] = useState('desc')
  const rows = useSortedUnits(perUnit, sortKey, sortDir)

  const totalToday = useMemo(
    () => rows.reduce((s, r) => s + (Number(r.sales_today) || 0), 0),
    [rows],
  )

  function toggle(key) {
    if (key === sortKey) setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'))
    else { setSortKey(key); setSortDir('desc') }
  }

  return (
    <BreakdownShell title="Today's Sales by location" onBack={onBack}>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-black/10 text-left text-[11px] uppercase tracking-wide text-black/55">
            <SortHeader label="Location" k="name" sortKey={sortKey} sortDir={sortDir} onClick={toggle} />
            <SortHeader label="Sales today" k="sales_today" sortKey={sortKey} sortDir={sortDir} onClick={toggle} align="right" />
            <SortHeader label="vs last week" k="sales_today_vs_prior_week_pct" sortKey={sortKey} sortDir={sortDir} onClick={toggle} align="right" />
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-b border-black/5 last:border-b-0">
              <td className="py-2.5 pr-3 font-medium text-black/85">{r.name}</td>
              <td className="py-2.5 pl-3 text-right tabular-nums text-black/85">{formatMoney(r.sales_today)}</td>
              <td className="py-2.5 pl-3 text-right tabular-nums">{pctCell(r.sales_today_vs_prior_week_pct)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="border-t-2 border-black/15 font-semibold">
            <td className="py-2.5 pr-3 text-black/85">All units</td>
            <td className="py-2.5 pl-3 text-right tabular-nums text-black/85">{formatMoney(totalToday)}</td>
            <td className="py-2.5 pl-3 text-right text-black/40">—</td>
          </tr>
        </tfoot>
      </table>
    </BreakdownShell>
  )
}
